<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex xs6>
          <div class="primary--text">Transfer Ticket</div>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn fab small flat @click="handleCancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div class="mb-4">
            <strong>{{ $t('select_agent_to_transfer') }}</strong>
          </div>
          <template v-if="!loadingAgent">
            <div class="form-control mb-3" :class="{ 'has-error': errors.has('group') }">
              <div class="caption mb-1">Group <span class="red--text">*</span></div>
              <v-autocomplete
                v-model="input.group"
                :return-object="false"
                name="group"
                :loading="loading"
                :items="agentGroup"
                outline
                clearable
                :item-text="'groupname'"
                :item-value="'id'"
                class="default-input"
                single-line
                :hide-details="!errors.has('group')"
                :error="errors.has('group')"
                :error-messages="errors.first('group')"
                placeholder="Group"
                @change="onChangeGroup"
              />

              <span v-if="errors.has('group')" class="text-error">{{ errors.first('group') }}</span>
            </div>
            <div class="form-control mb-3" :class="{ 'has-error': errors.has('subgroup') }">
              <div class="caption mb-1">SubGroup</div>
              <v-autocomplete
                :key="`subgroup-${autocompleteTimestamp}`"
                v-model="input.subgroup"
                return-object
                name="subgroup"
                :loading="loading"
                :disabled="!input.group"
                :items="filterSubGroup"
                outline
                clearable
                :item-text="'subgroupname'"
                :item-value="'subgroupname'"
                class="default-input"
                single-line
                :hide-details="!errors.has('subgroup')"
                :error="errors.has('subgroup')"
                :error-messages="errors.first('subgroup')"
                placeholder="Sub Group"
                @change="onChangeSubGroup"
              />
              <span v-if="errors.has('subgroup')" class="text-error">{{
                errors.first('subgroup')
              }}</span>
            </div>
            <div class="form-control mb-3" :class="{ 'has-error': errors.has('agent') }">
              <div class="caption mb-1">Agent <span class="red--text">*</span></div>
              <v-autocomplete
                :key="`adminid-${autocompleteTimestamp}`"
                v-model="input.agent"
                :return-object="false"
                :disabled="!input.group"
                name="assignedTo"
                :loading="loading"
                :items="filterAgents"
                outline
                clearable
                :item-text="'adminid'"
                :item-value="'adminid'"
                class="default-input"
                single-line
                :hide-details="!errors.has('assignedTo')"
                :error="errors.has('assignedTo')"
                :error-messages="errors.first('assignedTo')"
                placeholder="Assigned to"
              />
              <span v-if="errors.has('agent')" class="text-error">{{ errors.first('agent') }}</span>
            </div>
            <div class="text-xs-center">
              <v-btn depressed color="primary" @click="handleSubmit">
                {{ $t('Transfer') }}
              </v-btn>
              <v-btn color="grey" outline @click="handleCancel">
                {{ $t('cancel') }}
              </v-btn>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      input: {
        group: '',
        subgroup: '',
        agent: ''
      },
      autocompleteTimestamp: moment().valueOf(),
      filterAgents: [],
      filterSubGroup: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    })
    // filterSubGroup() {
    //   if (this.input.group && this.agentSubGroup) {
    //     return this.agentSubGroup.filter((el) => {
    //       return el.admingroupid == this.input.group.id
    //     })
    //   } else {
    //     return []
    //   }
    // },
    // filterAgents() {
    //   let agents = []
    //   if (this.input.group) {
    //     agents = this.agents.filter((el) => {
    //       return el.admingroupid == this.input.group.id
    //     })

    //     if (this.input.subgroup) {
    //       agents = this.agents.filter((el) => {
    //         return el.adminsubgroupid == this.input.subgroup.id
    //       })
    //     }
    //   } else {
    //     agents = this.agents
    //   }

    //   return agents.length > 0 ? agents.map((el) => el.adminid) : []
    // }
  },
  async mounted() {
    if (this.agentGroup && this.agentGroup.length === 0) {
      await this.$store.dispatch('loadAgentGroups')
    }
    if (this.agentSubGroup && this.agentSubGroup.length === 0) {
      await this.$store.dispatch('loadAgentSubGroups')
    }
    if (this.agents && this.agents.length === 0) {
      await this.$store.dispatch('loadAgents')
    }
    this.handleFilterSubGroup()
    this.handleFilterAgents()
  },
  methods: {
    handleFilterSubGroup() {
      if (this.input.group) {
        this.filterSubGroup = this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.input.group
        })
      } else {
        this.filterSubGroup = []
      }
    },
    handleFilterAgents() {
      if (this.input.group) {
        let agents = this.agents.filter((el) => {
          return el.admingroupid == this.input.group
        })
        if (this.input.subgroup) {
          agents = agents.filter((el) => {
            return el.adminsubgroupid == this.input.subgroup
          })
        }
        this.filterAgents = agents
      } else {
        this.filterAgents = this.agents ? this.agents : []
      }
    },
    async onChangeGroup() {
      this.input.subgroup = null
      this.input.agent = null
      this.handleFilterSubGroup()
      this.handleFilterAgents()
      await this.$nextTick()
      this.autocompleteTimestamp = moment().valueOf()
    },

    async onChangeSubGroup() {
      this.input.agent = null
      this.handleFilterSubGroup()
      this.handleFilterAgents()
      await this.$nextTick()
      this.autocompleteTimestamp = moment().valueOf()
    },
    async handleSubmit() {
      const vm = this
      const isValid = await vm.$validator.validate()

      if (!isValid) {
        return false
      }

      vm.$emit('selectedAgent', vm.input)
      vm.$emit('close')
    },
    handleCancel() {
      this.input = {
        group: '',
        subgroup: '',
        agent: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/DialogSelectAgent.vue